import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_GRID_AREAS, NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
import { NavigationItemContainer } from '../../NavigationItem/styles/navigation-item.styled';
import { NavigationItemsContainer } from '../../NavigationItems/styles/navigation-items.styled';
export const NAVIGATION_MAIN_SCROLL_BUTTON_SIZE = 70;
export const NAVIGATION_MAIN_SCROLL_FADE_SIZE = 36;
/**
 * Navigation main container
 */
export const navigationMainContainerStyles = () => css `
	grid-area: ${NAVIGATION_GRID_AREAS.MAIN};
	align-self: stretch;
	position: relative;
	display: flex;
	align-items: stretch;
	width: 100%;
	max-width: 100%;
	overflow: hidden;

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		align-self: stretch;
	}
`;
export const NavigationMainContainer = styled.div `
	${navigationMainContainerStyles}
`;
export const navigationMainInnerStyles = ({ theme, $navigationIsOpen, }) => css `
	display: none;
	flex-direction: column;
	align-items: stretch;
	width: 100%;
	max-height: 100%;
	overflow-y: auto;
	background-color: ${theme.colors.blanc.bgMainNavigation};
	content-visibility: hidden;
	scrollbar-width: none; /* firefox */

	&::-webkit-scrollbar {
		display: none;
	}

	${$navigationIsOpen &&
    css `
		display: flex;
		padding: ${pxToRem(theme.spacing['400'])} 0;
		content-visibility: visible;

		@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
			padding: 0;
		}
	`}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		align-items: stretch;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		content-visibility: visible;
		max-width: 100%;
		overflow: auto visible;

		& > ${NavigationItemsContainer} {
			flex-direction: row;

			& > ${NavigationItemContainer} {
				flex-direction: row;
				align-items: stretch;
			}
		}
	}
`;
export const NavigationMainInner = styled.nav `
	${navigationMainInnerStyles}
`;
export const navigationMainScrollButtonStyles = ({ theme, $position, }) => css `
	display: none;
	appearance: none;
	pointer-events: all;

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		position: absolute;
		top: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: ${pxToRem(NAVIGATION_MAIN_SCROLL_BUTTON_SIZE)};
		color: ${theme.colors.highlight.iconButton};
		border: none;
		background-color: ${theme.colors.blanc.bgMainNavigation};

		&:hover {
			color: ${theme.colors.highlight.iconButtonHover};
		}

		&:focus,
		&:active {
			color: ${theme.colors.action.iconActive};
		}

		${$position === 'left' &&
    css `
			left: 0;
		`}

		${$position === 'right' &&
    css `
			right: 0;
		`}

		&::before {
			content: '';
			position: absolute;
			top: 0;
			bottom: 0;
			width: ${pxToRem(NAVIGATION_MAIN_SCROLL_FADE_SIZE)};
			background: ${theme.colors.gradients.overlayHorizontalScroll};

			${$position === 'left' &&
    css `
				right: 0;
				transform: translateX(100%) rotate(180deg);
			`}

			${$position === 'right' &&
    css `
				left: 0;
				transform: translateX(-100%);
			`}
		}
	}
`;
export const NavigationMainScrollButton = styled.button `
	${navigationMainScrollButtonStyles}
`;
